<template>
	<v-container 
			class="customVContainer"
			:style="$_login_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<v-dialog
					v-model="showDialog_"
					:persistent="env.release"
					width="550px">
				<v-card class="card_"
						:color="$_login_styleCardColor"
						:dark="$_login_styleCardDark"
						:elevation="$_login_styleCardElevation"
						:flat="$_login_styleCardFlat"
						:hover="$_login_styleCardHover"
						:light="$_login_styleCardLight"
						:outlined="$_login_styleCardOutlined"
						:raised="$_login_styleCardRaised"
						:tile="$_login_styleCardTile">
					<v-card-title>
						<v-row class="my-2" justify="center">
							<v-col cols="auto">
								<span class="h5">Login</span>
							</v-col>
						</v-row>
					</v-card-title>
					<template v-if="!isFalse(errorMessage_)">
						<v-card-text>
							<span class="errorMessage_" v-html="errorMessage_" />
						</v-card-text>
					</template>
					<!-- select login optoin -->
					<template v-if="isEmpty(loginOption_)">
						<v-card-text class="cardText_">
							<v-select
									v-model="loginOption_"

									hide-details

									:background-color="$_login_styleSelectBackgroundColor"
									:chips="$_login_styleSelectChips"
									:clearable="$_login_styleSelectClearable"
									:color="$_login_styleSelectColor"
									:deletable-chips="$_login_styleSelectDeletableChips"
									:dark="$_login_styleSelectDark"
									:dense="$_login_styleSelectDense"
									:filled="$_login_styleSelectFilled"
									:flat="$_login_styleSelectFlat"
									:light="$_login_styleSelectLight"
									:outlined="$_login_styleSelectOutlined"
									:small-chips="$_login_styleSelectSmallChips"
									:solo="$_login_styleSelectSolo"
									:solo-inverted="$_login_styleSelectSoloInverted"

									:placeholder="$_login_langSelectLoginOptionPlaceholder"

									:label="$_login_langSelectLoginOption"

									item-text="title"
									item-value="key"
									:items="arrayObject(sortObject($_login_contentAppLoginOptions, 'order'))" />
						</v-card-text>
						<v-card-actions class="center">
							<v-row class="mb-4" dense justify="center">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_login_styleForgetPasswordButtonBlock"
											:color="$_login_styleForgetPasswordButtonColor"
											:dark="$_login_styleForgetPasswordButtonDark"
											:depressed="$_login_styleForgetPasswordButtonDepressed"
											:elevation="$_login_styleForgetPasswordButtonElevation"
											:large="$_login_styleForgetPasswordButtonLarge"
											:light="$_login_styleForgetPasswordButtonLight"
											:outlined="$_login_styleForgetPasswordButtonOutlined"
											:rounded="$_login_styleForgetPasswordButtonRounded"
											:small="$_login_styleForgetPasswordButtonSmall"
											:text="$_login_styleForgetPasswordButtonFlat"
											to="/forget-password">
										<span class="overline" v-text="$_login_langForgetPassword" />
									</v-btn>
								</v-col>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_login_styleSignUpButtonBlock"
											:color="$_login_styleSignUpButtonColor"
											:dark="$_login_styleSignUpButtonDark"
											:depressed="$_login_styleSignUpButtonDepressed"
											:elevation="$_login_styleSignUpButtonElevation"
											:large="$_login_styleSignUpButtonLarge"
											:light="$_login_styleSignUpButtonLight"
											:outlined="$_login_styleSignUpButtonOutlined"
											:rounded="$_login_styleSignUpButtonRounded"
											:small="$_login_styleSignUpButtonSmall"
											:text="$_login_styleSignUpButtonFlat"
											to="/sign-up">
										<span class="overline" v-text="$_login_langSignUp" />
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</template>
					<!-- input field -->
					<template v-else>
						<validation-observer v-slot="validation">
							<v-form>
								<v-card-text class="cardText_">
									<template v-if="loginOption_ == 'username'">
										<validation-provider
												name="Username"
												rules="required"
												mode="lazy"
												v-slot="{ errors }">
											<v-text-field
													v-model="form_.username"

													hide-details

													:background-color="$_login_styleTextFieldBackgroundColor"
													:clearable="$_login_styleTextFieldClearable"
													:color="$_login_styleTextFieldColor"
													:counter="$_login_styleTextFieldCounter"
													:dark="$_login_styleTextFieldDark"
													:filled="$_login_styleTextFieldFilled"
													:flat="$_login_styleTextFieldFlat"
													:light="$_login_styleTextFieldLight"
													:outlined="$_login_styleTextFieldOutlined"
													:solo="$_login_styleTextFieldSolo"
													:solo-inverted="$_login_styleTextFieldSoloInverted"

													:hint="$_login_langUsernameHint"
													:mask="$_login_langUsernameMask"
													:message="$_login_langUsernameMessage"
													:placeholder="$_login_langUsernamePlaceholder"
													:prefix="$_login_langUsernamePrefix"
													:suffix="$_login_langUsernameSuffix"
													:type="$_login_langUsernameType"

													:label="$_login_langUsername"

													:error-messages="errors" />
										</validation-provider>
									</template>
									<template v-if="loginOption_ == 'email'">
										<validation-provider
												name="Email address"
												rules="required|email"
												mode="lazy"
												v-slot="{ errors }">
											<v-text-field
													v-model="form_.email"

													hide-details

													:background-color="$_login_styleTextFieldBackgroundColor"
													:clearable="$_login_styleTextFieldClearable"
													:color="$_login_styleTextFieldColor"
													:counter="$_login_styleTextFieldCounter"
													:dark="$_login_styleTextFieldDark"
													:filled="$_login_styleTextFieldFilled"
													:flat="$_login_styleTextFieldFlat"
													:light="$_login_styleTextFieldLight"
													:outlined="$_login_styleTextFieldOutlined"
													:solo="$_login_styleTextFieldSolo"
													:solo-inverted="$_login_styleTextFieldSoloInverted"

													:hint="$_login_langEmailHint"
													:mask="$_login_langEmailMask"
													:message="$_login_langEmailMessage"
													:placeholder="$_login_langEmailPlaceholder"
													:prefix="$_login_langEmailPrefix"
													:suffix="$_login_langEmailSuffix"
													:type="$_login_langEmailType"

													:label="$_login_langEmail"

													:error-messages="errors" />
										</validation-provider>
									</template>
									<template v-if="loginOption_ == 'phone'">
										<validation-provider
												name="Phone number"
												rules="required|phone"
												mode="lazy"
												v-slot="{ errors }">
											<v-text-field
													v-model="form_.phone"

													hide-details

													:background-color="$_login_styleTextFieldBackgroundColor"
													:clearable="$_login_styleTextFieldClearable"
													:color="$_login_styleTextFieldColor"
													:counter="$_login_styleTextFieldCounter"
													:dark="$_login_styleTextFieldDark"
													:filled="$_login_styleTextFieldFilled"
													:flat="$_login_styleTextFieldFlat"
													:light="$_login_styleTextFieldLight"
													:outlined="$_login_styleTextFieldOutlined"
													:solo="$_login_styleTextFieldSolo"
													:solo-inverted="$_login_styleTextFieldSoloInverted"

													:hint="$_login_langPhoneHint"
													:mask="$_login_langPhoneMask"
													:message="$_login_langPhoneMessage"
													:placeholder="$_login_langPhonePlaceholder"
													:prefix="$_login_langPhonePrefix"
													:suffix="$_login_langPhoneSuffix"
													:type="$_login_langPhoneType"

													:label="$_login_langPhone"

													:error-messages="errors" />
										</validation-provider>
									</template>
								</v-card-text>
								<v-card-text class="cardText_">
									<validation-provider
											name="Password"
											rules="required"
											v-slot="{ errors }">
										<v-text-field
												v-model="form_.password"

												hide-details

												:background-color="$_login_styleTextFieldBackgroundColor"
												:clearable="$_login_styleTextFieldClearable"
												:color="$_login_styleTextFieldColor"
												:counter="$_login_styleTextFieldCounter"
												:dark="$_login_styleTextFieldDark"
												:filled="$_login_styleTextFieldFilled"
												:flat="$_login_styleTextFieldFlat"
												:light="$_login_styleTextFieldLight"
												:outlined="$_login_styleTextFieldOutlined"
												:solo="$_login_styleTextFieldSolo"
												:solo-inverted="$_login_styleTextFieldSoloInverted"

												:hint="$_login_langPasswordHint"
												:mask="$_login_langPasswordMask"
												:message="$_login_langPasswordMessage"
												:placeholder="$_login_langPasswordPlaceholder"
												:prefix="$_login_langPasswordPrefix"
												:suffix="$_login_langPasswordSuffix"

												:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
												:type="showPassword_ ? 'text' : 'password'"

												:label="$_login_langPassword"

												:error-messages="errors"
												@click:append="showPassword_ = !showPassword_" />
									</validation-provider>
								</v-card-text>
								<v-card-actions class="center">
									<v-row class="mb-4" dense justify="center">
										<v-col cols="auto">
											<v-btn	class="customVBtn"

													:disabled="!validation.passed && !validation.valid"

													:block="$_login_styleLoginButtonBlock"
													:color="$_login_styleLoginButtonColor"
													:dark="$_login_styleLoginButtonDark"
													:depressed="$_login_styleLoginButtonDepressed"
													:elevation="$_login_styleLoginButtonElevation"
													:large="$_login_styleLoginButtonLarge"
													:light="$_login_styleLoginButtonLight"
													:outlined="$_login_styleLoginButtonOutlined"
													:rounded="$_login_styleLoginButtonRounded"
													:small="$_login_styleLoginButtonSmall"
													:text="$_login_styleLoginButtonFlat"
													@click="$_login_login()"
													v-text="$_login_langLoginButton" />
										</v-col>
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_login_styleCancelButtonBlock"
													:color="$_login_styleCancelButtonColor"
													:dark="$_login_styleCancelButtonDark"
													:depressed="$_login_styleCancelButtonDepressed"
													:elevation="$_login_styleCancelButtonElevation"
													:large="$_login_styleCancelButtonLarge"
													:light="$_login_styleCancelButtonLight"
													:outlined="$_login_styleCancelButtonOutlined"
													:rounded="$_login_styleCancelButtonRounded"
													:small="$_login_styleCancelButtonSmall"
													:text="$_login_styleCancelButtonFlat"
													@click="$_login_cancel()"
													v-text="$_login_langCancelButton" />
										</v-col>
									</v-row>
								</v-card-actions>
								<!-- custom for bri life start -->
								<v-card-actions class="center">
									<v-row dense justify="space-between">
										<v-col cols="auto">
											<v-btn	:block="$_login_styleForgetPasswordButtonBlock"
													:color="$_login_styleForgetPasswordButtonColor"
													:dark="$_login_styleForgetPasswordButtonDark"
													:depressed="$_login_styleForgetPasswordButtonDepressed"
													:large="$_login_styleForgetPasswordButtonLarge"
													:light="$_login_styleForgetPasswordButtonLight"
													:outlined="$_login_styleForgetPasswordButtonOutlined"
													:rounded="$_login_styleForgetPasswordButtonRounded"
													:small="$_login_styleForgetPasswordButtonSmall"
													:text="$_login_styleForgetPasswordButtonFlat"
													to="/forget-password">
												Lupa Kata Sandi
											</v-btn>
										</v-col>
										<v-col cols="auto">
											<v-btn	:block="$_login_styleForgetPasswordButtonBlock"
													:color="$_login_styleForgetPasswordButtonColor"
													:dark="$_login_styleForgetPasswordButtonDark"
													:depressed="$_login_styleForgetPasswordButtonDepressed"
													:large="$_login_styleForgetPasswordButtonLarge"
													:light="$_login_styleForgetPasswordButtonLight"
													:outlined="$_login_styleForgetPasswordButtonOutlined"
													:rounded="$_login_styleForgetPasswordButtonRounded"
													:small="$_login_styleForgetPasswordButtonSmall"
													:text="$_login_styleForgetPasswordButtonFlat"
													@click="openLink({ url: 'mailto:bri-life-v3-4e197@benefit-one.co.id' })">
												Hubungi Kami
											</v-btn>
										</v-col>
									</v-row>
								</v-card-actions>
								<!-- custom for bri life end -->
							</v-form>
						</validation-observer>
					</template>
				</v-card>
			</v-dialog>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	export default {
		name: 'Login',
		data() {
			return {
				pageName_: 'login',
				pageType_: 'login',

				initialized_: false,

				showDialog_: true,

				// custom for bri life start
				loginOption_: 'username',
				// custom for bri life end
				showPassword_: false,
				errorMessage_: null,

				form_: {
					username: null,
					email: null,
					phone: null,
					password: null
				}
			}
		},
		computed: {
			// custom for bri life start
			$_login_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// custom for bri life end
			// queries
			$_login_query() {
				const self_ = this;
				const route_ = self_.$route
				return route_.query
			},
			$_login_queryToken() {
				const self_ = this;
				const query_ = self_.$_login_query;
				if(self_.isFalse(query_)) { return null }
				return query_.token
			},
			// current user
			$_login_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_login_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_login_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// loginOptions
			$_login_contentAppLoginOptions() {
				const self_ = this;
				const contents_ = self_.getAppContents('loginOptions')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			// contents / inits
			$_login_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_login_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_login_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_login_inits(), 'contact')
			},
			// lang
			$_login_langAppLoginOptionTitle() {
				const self_ = this;
				return title => {
					return self_.getLangsVal(title)
				}	
			},
			$_login_langCancelButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'cancelButton')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsername() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'username')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernameHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernameHint')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernameMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernameMask')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernameMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernameMessage')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernamePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernamePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernamePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernamePrefix')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernameSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernameSuffix')
				return self_.getLangsVal(lang_)
			},
			$_login_langUsernameType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'usernameType')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmail() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'email')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailHint')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailMask')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailMessage')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailPrefix')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailSuffix')
				return self_.getLangsVal(lang_)
			},
			$_login_langEmailType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'emailType')
				return self_.getLangsVal(lang_)
			},
			$_login_langLoginButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'loginButton')
				return self_.getLangsVal(lang_)
			},
			$_login_langForgetPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'forgetPassword')
				return self_.getLangsVal(lang_)
			},
			$_login_langSignUp() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'signUp')
				return self_.getLangsVal(lang_)
			},
			$_login_langPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'password')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordHint')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordMask')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordMessage')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_login_langPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'passwordType')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhone() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phone')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhoneHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phoneHint')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhoneMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phoneMask')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhoneMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phoneMessage')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhonePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phonePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhonePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phonePrefix')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhoneSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phoneSuffix')
				return self_.getLangsVal(lang_)
			},
			$_login_langPhoneType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'phoneType')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOption() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOption')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionHint')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionMask')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionMessage')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionPrefix')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionSuffix')
				return self_.getLangsVal(lang_)
			},
			$_login_langSelectLoginOptionType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_login_inits(), 'selectLoginOptionType')
				return self_.getLangsVal(lang_)
			},
			// link
			$_login_linkLoginButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_login_inits(), 'loginButton')
			},
			// style
			$_login_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'pageContainer')
			},
			$_login_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_login_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
			$_login_styleCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_login_inits(), 'card')
			},
			$_login_styleCardColor() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_login_styleCardDark() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_login_styleCardElevation() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_login_styleCardFlat() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_login_styleCardHover() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_login_styleCardLight() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_login_styleCardOutlined() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_login_styleCardRaised() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_login_styleCardTile() {
				const self_ = this;
				const card_ = self_.$_login_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_login_styleSelect() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'select')
			},
			$_login_styleSelectBackgroundColor() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.color)
			},
			$_login_styleSelectChips() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.chips)
			},
			$_login_styleSelectClearable() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.clearable)
			},
			$_login_styleSelectColor() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.color)
			},
			$_login_styleSelectDeletableChips() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.deletableChips)
			},
			$_login_styleSelectDark() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dark)
			},
			$_login_styleSelectDense() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dense)
			},
			$_login_styleSelectFilled() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.filled)
			},
			$_login_styleSelectFlat() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.flat)
			},
			$_login_styleSelectLight() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.light)
			},
			$_login_styleSelectOutlined() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.outlined)
			},
			$_login_styleSelectSmallChips() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.smallChips)
			},
			$_login_styleSelectSolo() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.solo)
			},
			$_login_styleSelectSoloInverted() {
				const self_ = this;
				const select_ = self_.$_login_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.soloInverted)
			},
			$_login_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'textField')
			},
			$_login_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_login_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_login_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_login_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_login_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_login_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_login_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_login_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_login_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_login_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_login_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_login_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_login_styleLoginButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'loginButton')
			},
			$_login_styleLoginButtonBlock() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_login_styleLoginButtonColor() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_login_styleLoginButtonDark() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_login_styleLoginButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_login_styleLoginButtonElevation() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_login_styleLoginButtonFlat() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_login_styleLoginButtonLarge() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_login_styleLoginButtonLight() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_login_styleLoginButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_login_styleLoginButtonRounded() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_login_styleLoginButtonSmall() {
				const self_ = this;
				const button_ = self_.$_login_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_login_styleForgetPasswordButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'forgetPasswordButton')
			},
			$_login_styleForgetPasswordButtonBlock() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_login_styleForgetPasswordButtonColor() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_login_styleForgetPasswordButtonDark() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_login_styleForgetPasswordButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_login_styleForgetPasswordButtonElevation() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_login_styleForgetPasswordButtonFlat() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_login_styleForgetPasswordButtonLarge() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_login_styleForgetPasswordButtonLight() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_login_styleForgetPasswordButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_login_styleForgetPasswordButtonRounded() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_login_styleForgetPasswordButtonSmall() {
				const self_ = this;
				const button_ = self_.$_login_styleForgetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_login_styleSignUpButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'signUpButton')
			},
			$_login_styleSignUpButtonBlock() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_login_styleSignUpButtonColor() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_login_styleSignUpButtonDark() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_login_styleSignUpButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_login_styleSignUpButtonElevation() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_login_styleSignUpButtonFlat() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_login_styleSignUpButtonLarge() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_login_styleSignUpButtonLight() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_login_styleSignUpButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_login_styleSignUpButtonRounded() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_login_styleSignUpButtonSmall() {
				const self_ = this;
				const button_ = self_.$_login_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_login_styleCancelButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_login_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_login_inits(), 'cancelButton')
			},
			$_login_styleCancelButtonBlock() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_login_styleCancelButtonColor() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_login_styleCancelButtonDark() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_login_styleCancelButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_login_styleCancelButtonElevation() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_login_styleCancelButtonFlat() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_login_styleCancelButtonLarge() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_login_styleCancelButtonLight() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_login_styleCancelButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_login_styleCancelButtonRounded() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_login_styleCancelButtonSmall() {
				const self_ = this;
				const button_ = self_.$_login_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_login_setPageState()

			if(self_.$_login_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_login_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			const router_ = self_.$router;

			self_.beforeMountPage(self_.pageName_)

			// single sign on
			if(!self_.isFalse(self_.$_login_queryToken)) {
/* debug */		self_.logDebug('Login Token', '', { token: self_.$_login_queryToken })

				self_.loginByCustomToken(self_.$_login_queryToken)
				router_.replace('/')
			}			
			// already logged in
			else if(!self_.isEmpty(self_.$_login_currentUser)) { router_.replace('/') }
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_login_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_login_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_login_initialize()', error)
				})
			},
			$_login_login() {
				const self_ = this;

				let email_ = '';
				if(self_.loginOption_ == 'username') {	email_ = 'boid.dev.app+' + self_.appId + '-' + self_.form_.username + '@gmail.com' }
				if(self_.loginOption_ == 'email') {	email_ = self_.form_.email }
				if(self_.loginOption_ == 'phone') {
					if(self_.form_.phone.substr(0, 4) == 'test' || self_.form_.phone == 'admin') {
						email_ = 'boid.dev.app+' + self_.appId + '-' + self_.form_.phone + '@gmail.com'
					} else {
						email_ = 'boid.dev.app+' + self_.appId + '-08' + self_.form_.phone + '@gmail.com'
					}
				}

				const password_ = self_.form_.password;

				Promise.resolve().then(() => {
					return self_.login(email_, password_)
				}).then(() => {
					self_.openLink(self_.$_login_linkLoginButton) 

/* info */			self_.logInfo('Login', 'User has logged in.')
				}).catch(error => {
/* error */			self_.logError('Error', '$_login_login()', error)
					// error message
					self_.errorMessage_ = 'Wrong username or password';
				})
			},
			$_login_cancel() {
				const self_ = this;

				// custom for bri life start
				self_.$router.replace('/')
				// custom for bri life end

				self_.loginOption_ = '';

				self_.form_ = {
					username: null,
					email: null,
					phone: null,
					password: null
				}

				self_.showPassword_ = false;
				self_.errorMessage_ = null;
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.card_ {
			padding: 0 48px;
		}
	}
	@media screen and (max-width:959px) {
		.card_ {
			padding: 0 12px;
		}
	}
	.errorMessage_ {
		color: red;
	}
	.cardText_ {
		padding-top: 0 !important;
	}
</style>